// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../../../assets/stylesheets/variables.scss\"","midnightColor":"#201C1C","mobileThreshold":"575px","button":"ShapeSelectOption_button__2rTuc"};